import {
  VisitListTheme,
  VisitListItemTheme,
  AvatarGroupTheme,
  VisitStatusTheme,
} from "./types";

// ============= Default Themes =============

export const defaultVisitListTheme: VisitListTheme = {
  container: "p-4",
  header: {
    title: "text-2xl font-semibold mb-2",
    subtitle: "text-sm opacity-80",
  },
  section: {
    container: "mb-8",
    title: "text-base font-semibold mb-3 opacity-80",
    emptyText: "text-sm opacity-60",
  },
};

export const defaultVisitListItemTheme: VisitListItemTheme = {
  container: {
    base: "flex p-6 rounded-2xl border border-gray-200 bg-white transition-all duration-200 w-full",
    hover: "hover:scale-[1.01]",
    active: "active:scale-[0.99]",
    clickable: "cursor-pointer",
  },
  content: {
    container: "flex-1 flex flex-col gap-1",
    title: "text-[17px] font-semibold",
    subtitle: "text-sm opacity-80",
  },
  chevron: "w-6 h-6 opacity-40",
  notificationCard: {
    container: "p-3 flex items-start gap-2 rounded-b-2xl -mt-px",
    icon: "w-4 h-4 flex-shrink-0",
    text: "text-sm leading-5",
  },
};

export const defaultAvatarGroupTheme: AvatarGroupTheme = {
  container: "flex items-center gap-1",
  avatar: {
    base: "rounded-full overflow-hidden flex items-center justify-center",
    first: "",
    second: "",
    placeholder: "bg-gray-300",
  },
  separator: "w-4 h-0.5 rounded-full bg-gray-200",
  sizes: {
    small: "w-8 h-8 text-sm",
    medium: "w-10 h-10 text-base",
    large: "w-12 h-12 text-lg",
  },
};

export const defaultVisitStatusTheme: VisitStatusTheme = {
  container: "flex items-center gap-2",
  text: {
    base: "text-sm font-medium",
    requested: "text-orange-500",
    active: "text-blue-500",
    completed: "text-gray-500",
    cancelled: "text-red-500",
  },
  icon: {
    base: "w-3 h-3",
    requested: "",
    active: "",
    completed: "",
    cancelled: "",
  },
  timestamp: "text-xs opacity-60",
};
